import axios from 'axios'
import i18n from './../plugins/i18n'

export default {
  isSubscribed(npaId) {
    return axios.get(`${i18n.locale}/api/subscription/isSubscribed/${npaId}`)
  },

  subscribeNpa(npaId) {
    return axios.post(`${i18n.locale}/api/subscription/npa/subscribe/${npaId}`)
  },

  unsubscribeNpa(npaId) {
    return axios.post(
      `${i18n.locale}/api/subscription/npa/unsubscribe/${npaId}`
    )
  },

  unsubscribeNewsletter(id) {
    return axios.post(
      `${i18n.locale}/api/subscription/newsletter/unsubscribe/${id}`
    )
  },

  subscribeNewsletter(data) {
    return axios.post(
      `${i18n.locale}/api/subscription/newsletter/subscribe`,
      data
    )
  },

  profileSubs(sorting) {
    let sort = ''

    for (let field in sorting) {
      sort += `${field}=${sorting[field]}&`
    }

    return axios
      .get(`${i18n.locale}/api/subscription/profileSubs/?${sort}`)
      .then((response) => {
        return Promise.resolve(response.data)
      })
  }
}
